import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/*import { register, load, getInstances } from '@shopify/theme-sections';

Avatar.theme = Avatar.theme || {};
Avatar.theme.sections = Avatar.theme.sections || {};

Avatar.theme.sections.Collection = (function Collection() {
  const selectors = {
    filterSelection: '[data-filter]',
    filterSelectIcon: '[data-filter-select-icon]',
    filterOptionsDropdown: '[data-filter-options-dropdown]',
    sortSelection: '[data-sort]',
    sortSelectIcon: '[data-sort-select-icon]',
    sortOptionsDropdown: '[data-sort-options-dropdown]',
    selectInput: '[data-select-input]',
    optionValues: '[data-value]',
  };

  const classes = {
    opacityFull: 'tw-opacity-100',
    hide: 'tw-hidden',
    rotate: 'tw-rotate-180',
  };

  register('collection-template', {
    onLoad() {
      const { container } = this;

      this.filterSelect = container.querySelector(selectors.filterSelection);
      this.filterSelectIcon = container.querySelector(selectors.filterSelectIcon);
      this.sortSelect = container.querySelector(selectors.sortSelection);
      this.sortSelectIcon = container.querySelector(selectors.sortSelectIcon);

      // For Custom Dropdown
      this.filterOptionsDropdown = container.querySelector(selectors.filterOptionsDropdown);
      // Might need again if we decided to make a filter that can use AND / OR filtering
      this.optionValues = container.querySelectorAll(selectors.optionValues);
      this.sortOptionsDropdown = container.querySelector(selectors.sortOptionsDropdown);

      this.selects = container.querySelectorAll(selectors.selectInput);

      this.eventHandlers = {};

      if (this.sortSelect) {
        this.defaultSort = this._getDefaultSortValue();
      }

      if (this.selects.length) {
        this.selects.forEach(select => {
          select.classList.remove('hidden');
        });
      }

      if (this.filterSelect) {
        if (this.filterSelect.dataset.selectInput === 'custom') {
          this.eventHandlers._onCustomFilterClick = this._onCustomFilterClick.bind(this);
          this.filterSelect.addEventListener('click', this.eventHandlers._onCustomFilterClick);

          this.eventHandlers._onFilterKeyUp = this._onFilterKeyUp.bind(this);
          this.filterSelect.parentElement.addEventListener('keyup', this.eventHandlers._onFilterKeyUp);

          this.eventHandlers._onFilterToggleFocusOut = this._onFilterToggleFocusOut.bind(this);
          this.filterSelect.addEventListener('focusout', this.eventHandlers._onFilterToggleFocusOut);

          this.eventHandlers._onFilterDropdownFocusOut = this._onFilterDropdownFocusOut.bind(this);
          this.filterOptionsDropdown.addEventListener('focusout', this.eventHandlers._onFilterDropdownFocusOut);
        } else {
          this.filterSelect.addEventListener('change', this._onFilterChange.bind(this));
        }
      }

      if (this.sortSelect) {
        if (this.sortSelect.dataset.selectInput === 'custom') {
          this.eventHandlers._onCustomSortClick = this._onCustomSortClick.bind(this);
          this.sortSelect.addEventListener('click', this.eventHandlers._onCustomSortClick);

          this.eventHandlers._onCustomOptionClick = this._onCustomOptionClick.bind(this);
          this.optionValues.forEach(option => option.addEventListener('click', this.eventHandlers._onCustomOptionClick));

          this.eventHandlers._onSortKeyUp = this._onSortKeyUp.bind(this);
          this.sortSelect.parentElement.addEventListener('keyup', this.eventHandlers._onSortKeyUp);

          this.eventHandlers._onSortToggleFocusOut = this._onSortToggleFocusOut.bind(this);
          this.sortSelect.addEventListener('focusout', this.eventHandlers._onSortToggleFocusOut);

          this.eventHandlers._onSortDropdownFocusOut = this._onSortDropdownFocusOut.bind(this);
          this.sortOptionsDropdown.addEventListener('focusout', this.eventHandlers._onSortDropdownFocusOut);
        } else {
          this.sortSelect.addEventListener('change', this._onSortChange.bind(this));
        }
      }

      if (this.filterSelect || this.sortSelect) {
        this.eventHandlers._onBodyClick = this._onBodyClick.bind(this);
        document.body.addEventListener('click', this.eventHandlers._onBodyClick);
      }

      this._initParams();
    },

    _initParams() {
      this.queryParams = {};
      if (location.search.length) {
        let aKeyValue;
        const aCouples = location.search.substr(1).split('&');
        aCouples.forEach(aCouple => {
          aKeyValue = aCouple.split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        });
      }
    },

    _onSortChange() {
      this.queryParams.sort_by = this._getSortValue();

      if (this.queryParams.page) {
        delete this.queryParams.page;
      }

      window.location.search = decodeURIComponent(
        new URLSearchParams(Object.entries(this.queryParams)).toString()
      );
    },

    _onCustomSortClick() {
      this._toggleDropdown(this.sortOptionsDropdown, this.sortSelectIcon, this.sortSelect);
    },

    _onFilterChange() {
      document.location.href = this._getFilterValue();
    },

    _onCustomFilterClick() {
      this._toggleDropdown(this.filterOptionsDropdown, this.filterSelectIcon, this.filterSelect);
    },

    _toggleDropdown(dropdown, icon, select) {
      if (dropdown.classList.contains(classes.opacityFull)) {
        dropdown.classList.remove(classes.opacityFull);
        icon.classList.remove(classes.rotate);
        setTimeout(() => {
          dropdown.classList.add(classes.hide);
        }, 100);
        select.setAttribute('aria-expanded', false);
      } else {
        dropdown.classList.remove(classes.hide);
        dropdown.classList.add(classes.opacityFull);
        icon.classList.add(classes.rotate);
        select.setAttribute('aria-expanded', true);
      }
    },

    _closeDropdown(dropdown, icon, select) {
      dropdown.classList.remove(classes.opacityFull);
      icon.classList.remove(classes.rotate);
      setTimeout(() => {
        dropdown.classList.add(classes.hide);
      }, 100);
      select.setAttribute('aria-expanded', false);
    },

    _onCustomOptionClick(evt) {
      evt.preventDefault();

      this.queryParams.sort_by = this._getCustomSortValue(evt);

      if (this.queryParams.page) {
        delete this.queryParams.page;
      }

      window.location.search = decodeURIComponent(
        new URLSearchParams(Object.entries(this.queryParams)).toString()
      );
    },

    _getSortValue() {
      return this.sortSelect.value || this.defaultSort;
    },

    _getCustomSortValue(evt) {
      return evt.currentTarget.dataset.value;
    },

    _getFilterValue() {
      return this.filterSelect.value;
    },

    _getDefaultSortValue() {
      return this.sortSelect.dataset.defaultSortby;
    },

    _onBodyClick(evt) {
      if (this.filterSelect) {
        if (
          !evt.target.closest(selectors.filterOptionsDropdown)
          && !evt.target.closest(selectors.filterSelection)
        ) {
          this._closeDropdown(this.filterOptionsDropdown, this.filterSelectIcon, this.filterSelect);
        }
      }

      if (this.sortSelect) {
        if (
          !evt.target.closest(selectors.sortOptionsDropdown)
          && !evt.target.closest(selectors.sortSelection)
        ) {
          this._closeDropdown(this.sortOptionsDropdown, this.sortSelectIcon, this.sortSelect);
        }
      }
    },

    _onFilterKeyUp(evt) {
      if (evt.which !== 27) return;
      this._closeDropdown(this.filterOptionsDropdown, this.filterSelectIcon, this.filterSelect);
      this.filterSelect.focus();
    },

    _onSortKeyUp(evt) {
      if (evt.which !== 27) return;
      this._closeDropdown(this.sortOptionsDropdown, this.sortSelectIcon, this.sortSelect);
      this.sortSelect.focus();
    },

    _onFilterToggleFocusOut(evt) {
      const FilterLostFocus = this.filterOptionsDropdown.contains(evt.relatedTarget) === false;

      if (FilterLostFocus) {
        this._closeDropdown(this.filterOptionsDropdown, this.filterSelectIcon, this.filterSelect);
      }
    },

    _onFilterDropdownFocusOut(evt) {
      const childInFocus = evt.currentTarget.contains(evt.relatedTarget);

      const isVisible = this.filterOptionsDropdown.classList.contains(classes.opacityFull);

      if (isVisible && !childInFocus) {
        this._closeDropdown(this.filterOptionsDropdown, this.filterSelectIcon, this.filterSelect);
      }
    },

    _onSortToggleFocusOut(evt) {
      const SortLostFocus = this.sortOptionsDropdown.contains(evt.relatedTarget) === false;

      if (SortLostFocus) {
        this._closeDropdown(this.sortOptionsDropdown, this.sortSelectIcon, this.sortSelect);
      }
    },

    _onSortDropdownFocusOut(evt) {
      const childInFocus = evt.currentTarget.contains(evt.relatedTarget);

      const isVisible = this.sortOptionsDropdown.classList.contains(classes.opacityFull);

      if (isVisible && !childInFocus) {
        this._closeDropdown(this.sortOptionsDropdown, this.sortSelectIcon, this.sortSelect);
      }
    },

    onUnload() {
      if (this.sortSelect) {
        this.sortSelect.removeEventListener('click', this.eventHandlers._onCustomSortClick);

        this.optionValues.forEach(option => option.removeEventListener('click', this.eventHandlers._onCustomOptionClick));

        this.sortSelect.parentElement.removeEventListener('keyup', this.eventHandlers._onSortKeyUp);
        this.sortSelect.removeEventListener('focusout', this.eventHandlers._onSortToggleFocusOut);
        this.sortOptionsDropdown.removeEventListener('focusout', this.eventHandlers._onSortDropdownFocusOut);
      }

      if (this.filterSelect) {
        this.filterSelect.removeEventListener('click', this.eventHandlers._onCustomFilterClick);
        this.filterSelect.parentElement.removeEventListener('keyup', this.eventHandlers.onFilterKeyUp);
        this.filterSelect.removeEventListener('focusout', this.eventHandlers._onFilterToggleFocusOut);
        this.filterOptionsDropdown.removeEventListener('focusout', this.eventHandlers._onFilterDropdownFocusOut);
      }
      document.body.removeEventListener('click', this.eventHandlers._onBodyClick);
    }
  });

  load('collection-template');

  const instance = getInstances('collection-template');
  return instance[0];
})();*/
var CollectionFiltersForm = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CollectionFiltersForm, _HTMLElement);

  var _super = _createSuper(CollectionFiltersForm);

  function CollectionFiltersForm() {
    var _this;

    _classCallCheck(this, CollectionFiltersForm);

    _this = _super.call(this);
    _this.filterData = [];
    _this.onActiveFilterClick = _this.onActiveFilterClick.bind(_assertThisInitialized(_this));
    _this.debouncedOnSubmit = debounce(function (event) {
      _this.onSubmitHandler(event);
    }, 500);

    _this.querySelector('form').addEventListener('input', _this.debouncedOnSubmit.bind(_assertThisInitialized(_this)));

    window.addEventListener('popstate', _this.onHistoryChange.bind(_assertThisInitialized(_this)));

    _this.addClickOutsideHandler(document);

    return _this;
  }

  _createClass(CollectionFiltersForm, [{
    key: "addClickOutsideHandler",
    value: function addClickOutsideHandler(container) {
      var displays = container.querySelectorAll('.facets__display');
      displays.forEach(function (item) {
        hideOnClickOutside(item);
      });
    }
  }, {
    key: "onSubmitHandler",
    value: function onSubmitHandler(event) {
      var _event$target;

      event.preventDefault();

      if ((_event$target = event.target) !== null && _event$target !== void 0 && _event$target.classList.contains('handle')) {
        return;
      }

      var formData = new FormData(event.target.closest('form'));
      var searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
    }
  }, {
    key: "onActiveFilterClick",
    value: function onActiveFilterClick(event) {
      event.preventDefault();
      this.toggleActiveFacets();
      this.renderPage(new URL(event.currentTarget.href).searchParams.toString());
    }
  }, {
    key: "onHistoryChange",
    value: function onHistoryChange(event) {
      var _event$state;

      var searchParams = ((_event$state = event.state) === null || _event$state === void 0 ? void 0 : _event$state.searchParams) || '';
      this.renderPage(searchParams, null, false);
    }
  }, {
    key: "toggleActiveFacets",
    value: function toggleActiveFacets() {
      var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      document.querySelectorAll('.js-facet-remove').forEach(function (element) {
        element.classList.toggle('disabled', disable);
      });
    }
  }, {
    key: "renderPage",
    value: function renderPage(searchParams, event) {
      var _this2 = this;

      var updateURLHash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var sections = this.getSections();
      document.querySelector('.loading-overlay').classList.remove('tw-hidden');
      sections.forEach(function (section) {
        var url = "".concat(window.location.pathname, "?section_id=").concat(section.section, "&").concat(searchParams);

        var filterDataUrl = function filterDataUrl(element) {
          return element.url === url;
        };

        _this2.filterData.some(filterDataUrl) ? _this2.renderSectionFromCache(filterDataUrl, event) : _this2.renderSectionFromFetch(url, event);
      });
      if (updateURLHash) this.updateURLHash(searchParams);
    }
  }, {
    key: "renderSectionFromFetch",
    value: function renderSectionFromFetch(url, event) {
      var _this3 = this;

      fetch(url).then(function (response) {
        return response.text();
      }).then(function (responseText) {
        var html = responseText;
        _this3.filterData = [].concat(_toConsumableArray(_this3.filterData), [{
          html: html,
          url: url
        }]);

        _this3.renderFilters(html, event);

        _this3.renderProductGrid(html);

        _this3.renderProductCount(html);
      });
    }
  }, {
    key: "renderSectionFromCache",
    value: function renderSectionFromCache(filterDataUrl, event) {
      var html = this.filterData.find(filterDataUrl).html;
      this.renderFilters(html, event);
      this.renderProductGrid(html);
      this.renderProductCount(html);
    }
  }, {
    key: "renderProductGrid",
    value: function renderProductGrid(html) {
      document.getElementById('CollectionProductGrid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductGrid').innerHTML;
    }
  }, {
    key: "renderProductCount",
    value: function renderProductCount(html) {
      var count = new DOMParser().parseFromString(html, 'text/html').getElementById('CollectionProductCount').innerHTML;
      var containerDesktop = document.getElementById('CollectionProductCountDesktop');
      document.getElementById('CollectionProductCount').innerHTML = count;

      if (containerDesktop) {
        containerDesktop.innerHTML = count;
      }
    }
  }, {
    key: "renderFilters",
    value: function renderFilters(html, event) {
      var parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      var facetDetailsElements = parsedHTML.querySelectorAll('#CollectionFiltersForm .js-filter, #CollectionFiltersFormMobile .js-filter');

      var matchesIndex = function matchesIndex(element) {
        var _event$target$closest;

        return element.dataset.index === (event === null || event === void 0 ? void 0 : (_event$target$closest = event.target.closest('.js-filter')) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.dataset.index);
      };

      var facetsToRender = Array.from(facetDetailsElements).filter(function (element) {
        return !matchesIndex(element);
      });
      var countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
      var currentFacets = Array.from(facetDetailsElements).filter(function (element) {
        return matchesIndex(element);
      });
      currentFacets.forEach(function (element) {
        var target = document.querySelector(".js-filter[data-index=\"".concat(element.dataset.index, "\"]"));
        target.setAttribute('class', element.getAttribute('class'));

        if (target.dataset.index.includes('mobile')) {
          target.open = true;
          setTimeout(function () {
            target.classList.add('menu-opening');
          });
        }
      });
      facetsToRender.forEach(function (element) {
        var target = document.querySelector(".js-filter[data-index=\"".concat(element.dataset.index, "\"]"));
        target.innerHTML = element.innerHTML;
        target.setAttribute('class', element.getAttribute('class'));
      });
      this.addClickOutsideHandler(document);
      this.renderActiveFacets(parsedHTML);
      this.renderAdditionalElements(parsedHTML);
      if (countsToRender) this.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }
  }, {
    key: "renderActiveFacets",
    value: function renderActiveFacets(html) {
      var activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
      activeFacetElementSelectors.forEach(function (selector) {
        var activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      });
      this.toggleActiveFacets(false);
    }
  }, {
    key: "renderAdditionalElements",
    value: function renderAdditionalElements(html) {
      var mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
      mobileElementSelectors.forEach(function (selector) {
        if (!html.querySelector(selector)) return;
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      });
      document.getElementById('CollectionFiltersFormMobile').closest('menu-drawer').bindEvents();
    }
  }, {
    key: "renderCounts",
    value: function renderCounts(source, target) {
      var countElementSelectors = ['.count-bubble', '.facets__selected'];
      countElementSelectors.forEach(function (selector) {
        var targetElement = target.querySelector(selector);
        var sourceElement = source.querySelector(selector);

        if (sourceElement && targetElement) {
          target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
        }
      });
    }
  }, {
    key: "updateURLHash",
    value: function updateURLHash(searchParams) {
      history.pushState({
        searchParams: searchParams
      }, '', "".concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams)));
    }
  }, {
    key: "getSections",
    value: function getSections() {
      return [{
        id: 'main-collection',
        section: document.querySelector('[data-section-type="main-collection"]').dataset.sectionId
      }];
    }
  }]);

  return CollectionFiltersForm;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('collection-filters-form', CollectionFiltersForm);

var PriceRange = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(PriceRange, _HTMLElement2);

  var _super2 = _createSuper(PriceRange);

  function PriceRange() {
    var _this4;

    _classCallCheck(this, PriceRange);

    _this4 = _super2.call(this);

    _this4.querySelectorAll('input').forEach(function (element) {
      return element.addEventListener('change', _this4.onRangeChange.bind(_assertThisInitialized(_this4)));
    });

    _this4.querySelectorAll('input[type="range"]').forEach(function (element) {
      return element.addEventListener('input', _this4.onSliderChange);
    });

    _this4.setMinAndMaxValues();

    _this4.initSlider();

    return _this4;
  }

  _createClass(PriceRange, [{
    key: "initSlider",
    value: function initSlider() {
      var slider = PriceRange.getSliderElements(this);

      if (!slider.inputLeft) {
        return;
      } // Percentages


      var perecentage = Number(slider.inputLeft.value) * 100 / Number(slider.inputLeft.getAttribute('max'));
      var inversePercentage = 100 - perecentage;
      var perecentageTwo = Number(slider.inputRight.value) * 100 / Number(slider.inputRight.getAttribute('max'));
      var inversePercentageTwo = 100 - perecentageTwo;
      slider.inverseLeft.style.width = inversePercentage + '%';
      slider.inverseRight.style.width = inversePercentage + '%';
      slider.range.style.left = perecentage + '%';
      slider.range.style.right = inversePercentageTwo + '%';
      slider.thumbLeft.style.left = perecentage + '%';
      slider.thumbRight.style.left = perecentageTwo + '%';
    }
  }, {
    key: "onRangeChange",
    value: function onRangeChange(event) {
      if (event.currentTarget.classList.contains('handle')) {
        this.syncValuesFromSlider();
        return;
      }

      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }
  }, {
    key: "onSliderChange",
    value: function onSliderChange(event) {
      var input = event.currentTarget;
      var container = input.closest('.facets__price');
      var slider = PriceRange.getSliderElements(container);

      if (input.dataset.handle === 'left') {
        input.value = Math.min(input.value, slider.inputRight.value - 1);
        var value = 100 / (parseInt(input.max) - parseInt(input.min)) * parseInt(input.value) - 100 / (parseInt(input.max) - parseInt(input.min)) * parseInt(input.min);
        slider.inverseLeft.style.width = value + '%';
        slider.range.style.left = value + '%';
        slider.thumbLeft.style.left = value + '%';
      }

      if (input.dataset.handle === 'right') {
        input.value = Math.max(input.value, slider.inputLeft.value - -1);

        var _value = 100 / (parseInt(input.max) - parseInt(input.min)) * parseInt(input.value) - 100 / (parseInt(input.max) - parseInt(input.min)) * parseInt(input.min);

        slider.inverseRight.style.width = 100 - _value + '%';
        slider.range.style.right = 100 - _value + '%';
        slider.thumbRight.style.left = _value + '%';
      }
    }
  }, {
    key: "setMinAndMaxValues",
    value: function setMinAndMaxValues() {
      var inputs = this.querySelectorAll('input:not([type="range"])');
      var minInput = inputs[0];
      var maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
  }, {
    key: "adjustToValidValues",
    value: function adjustToValidValues(input) {
      var value = Number(input.value);
      var min = Number(input.getAttribute('min'));
      var max = Number(input.getAttribute('max'));
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }, {
    key: "syncValuesFromSlider",
    value: function syncValuesFromSlider() {
      var sliderInputs = this.querySelectorAll('input[type="range"]');
      var sliderMinInput = sliderInputs[0];
      var sliderMaxInput = sliderInputs[1];
      var inputs = this.querySelectorAll('input:not([type="range"])');
      var minInput = inputs[0];
      var maxInput = inputs[1];

      if (minInput.value !== sliderMinInput.value) {
        minInput.value = Number(sliderMinInput.value);
        minInput.dispatchEvent(new Event('input', {
          bubbles: true,
          cancelable: true
        }));
      }

      if (maxInput.value !== sliderMaxInput.value) {
        maxInput.value = Number(sliderMaxInput.value);
        maxInput.dispatchEvent(new Event('input', {
          bubbles: true,
          cancelable: true
        }));
      }
    }
  }], [{
    key: "getSliderElements",
    value: function getSliderElements(container) {
      return {
        'inverseLeft': container === null || container === void 0 ? void 0 : container.querySelector('div[inverse-left]'),
        'inverseRight': container === null || container === void 0 ? void 0 : container.querySelector('div[inverse-right]'),
        'range': container === null || container === void 0 ? void 0 : container.querySelector('div[range]'),
        'thumbLeft': container === null || container === void 0 ? void 0 : container.querySelector('span[thumb-left]'),
        'thumbRight': container === null || container === void 0 ? void 0 : container.querySelector('span[thumb-right]'),
        'inputLeft': container.querySelector('input[data-handle="left"]'),
        'inputRight': container.querySelector('input[data-handle="right"]')
      };
    }
  }]);

  return PriceRange;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('price-range', PriceRange);

var FacetRemove = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(FacetRemove, _HTMLElement3);

  var _super3 = _createSuper(FacetRemove);

  function FacetRemove() {
    var _this5;

    _classCallCheck(this, FacetRemove);

    _this5 = _super3.call(this);

    _this5.querySelector('a').addEventListener('click', function (event) {
      event.preventDefault();
      var form = _this5.closest('collection-filters-form') || document.querySelector('collection-filters-form');
      form.onActiveFilterClick(event);
    });

    return _this5;
  }

  return FacetRemove;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('facet-remove', FacetRemove);

var MenuDrawer = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(MenuDrawer, _HTMLElement4);

  var _super4 = _createSuper(MenuDrawer);

  function MenuDrawer() {
    var _this6;

    _classCallCheck(this, MenuDrawer);

    _this6 = _super4.call(this);
    _this6.mainDetailsToggle = _this6.querySelector('details');

    var summaryElements = _this6.querySelectorAll('summary');

    _this6.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', "".concat(window.innerHeight, "px"));

    _this6.addEventListener('keyup', _this6.onKeyUp.bind(_assertThisInitialized(_this6)));

    _this6.addEventListener('focusout', _this6.onFocusOut.bind(_assertThisInitialized(_this6)));

    _this6.bindEvents();

    return _this6;
  }

  _createClass(MenuDrawer, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this7 = this;

      this.querySelectorAll('summary').forEach(function (summary) {
        return summary.addEventListener('click', _this7.onSummaryClick.bind(_this7));
      });
      this.querySelectorAll('button').forEach(function (button) {
        return button.addEventListener('click', _this7.onCloseButtonClick.bind(_this7));
      });
    }
  }, {
    key: "addAccessibilityAttributes",
    value: function addAccessibilityAttributes(summaryElements) {
      summaryElements.forEach(function (element) {
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', false);
        element.setAttribute('aria-controls', element.nextElementSibling.id);
      });
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      var openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
  }, {
    key: "onSummaryClick",
    value: function onSummaryClick(event) {
      var summaryElement = event.currentTarget;
      var detailsElement = summaryElement.parentNode;
      var isOpen = detailsElement.hasAttribute('open');

      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
      } else {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        setTimeout(function () {
          detailsElement.classList.add('menu-opening');
        });
      }
    }
  }, {
    key: "openMenuDrawer",
    value: function openMenuDrawer(summaryElement) {
      var _this8 = this;

      setTimeout(function () {
        _this8.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add("overflow-hidden-".concat(this.dataset.breakpoint));
    }
  }, {
    key: "closeMenuDrawer",
    value: function closeMenuDrawer(event) {
      var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (event !== undefined) {
        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(function (details) {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
        document.body.classList.remove("overflow-hidden-".concat(this.dataset.breakpoint));
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
      }
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut(event) {
      var _this9 = this;

      setTimeout(function () {
        if (_this9.mainDetailsToggle.hasAttribute('open') && !_this9.mainDetailsToggle.contains(document.activeElement)) _this9.closeMenuDrawer();
      });
    }
  }, {
    key: "onCloseButtonClick",
    value: function onCloseButtonClick(event) {
      var detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  }, {
    key: "closeSubmenu",
    value: function closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      removeTrapFocus();
      this.closeAnimation(detailsElement);
    }
  }, {
    key: "closeAnimation",
    value: function closeAnimation(detailsElement) {
      var animationStart;

      var handleAnimation = function handleAnimation(time) {
        if (animationStart === undefined) {
          animationStart = time;
        }

        var elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');

          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }]);

  return MenuDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('menu-drawer', MenuDrawer);

function debounce(fn, wait) {
  var _this10 = this;

  var t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this10, args);
    }, wait);
  };
}

var trapFocusHandlers = {};

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

function removeTrapFocus() {
  var elementToFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function trapFocus(container) {
  var elementToFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();

  trapFocusHandlers.focusin = function (event) {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.

    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    } //  On the first focusable element and tab backward, focus the last element.


    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();
}

function hideOnClickOutside(element) {
  var isVisible = function isVisible(elem) {
    return !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
  };

  var outsideClickListener = function outsideClickListener(event) {
    if (!element.contains(event.target) && isVisible(element)) {
      var _element$closest;

      (_element$closest = element.closest('details')) === null || _element$closest === void 0 ? void 0 : _element$closest.removeAttribute('open');
    }
  };

  document.addEventListener('click', outsideClickListener);
}


    // If we reached this module (the entry point), it means no one accepted the HRM.
    // Let's reload the page then.
    if (module.hot) {
      module.hot.accept();
      // On first load, module.hot.data is undefined since it is not an update...
      // So if we do have a data object, it means we've been HMR'ed.
      if (module.hot.data) {
        window.__shopify_pipeline_should_reload__ = true;
      }
    }
  